<template>
    <div class="test-from-editor">
        <h2 class="question__title mb-6" :class="{'question__compact': question.length>200}" v-html="question"></h2>
        <draggable v-model="answers" item-key="id" handle=".drag-handle" tag="transition-group"
            :component-data="{ props: { name: 'flip-list' } }" :animation="200" class="answers-list">
                <div class="col-12 my-2 d-flex align-center" v-for="(element, index) in answers" :key="element.id">
                    <v-icon class="mr-2 drag-handle" small>mdi-drag</v-icon>
                    <div class="flex-grow-1 justify-start ranked-answer-button" :elevation="0" outlined large>
                        {{ element.text }}
                    </div>
                    <v-btn icon small @click="moveUp(index)" :disabled="index===0">
                        <v-icon>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn icon small @click="moveDown(index)" :disabled="index===answers.length-1">
                        <v-icon>mdi-arrow-down</v-icon>
                    </v-btn>
                </div>
        </draggable>
        <v-btn class="btn-disabled-primary mb-4 mt-6 mx-auto" type="submit" x-large color="primary"
            :loading="loading" @click="onClickAnswer" :disabled="loading">
            Продолжить
        </v-btn>
        <!-- <div class="mt-4">
          <strong>Порядок ID:</strong> {{ answers.map(a => a.id) }}
        </div> -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';

export default {
    name: 'TestSimpleQuestion',
    components: { draggable },
    computed: {
        ...mapGetters({
            testData: 'testing/testing/testData',
            loading: 'testing/testing/loading',
            // selectedAnswer: 'testing/testing/selectedAnswer',
        }),
        question() {
            return `<span>${this.testData.question.text}<span>`;
        },
    },
    data() {
        return {
            answers: [],
        };
    },
    watch: {
        testData: {
            immediate: true,
            handler(val) {
                console.log('testData changed:', val.answer_options);
                if (val && val.answer_options) {
                  this.answers = [...val.answer_options];
                }
            },
        },
    },
    methods: {
        ...mapActions({
            sendAnswerRanked: 'testing/testing/sendAnswerRanked',
            setRankedAnswers: 'testing/testing/setRankedAnswers',
        }),
        async onClickAnswer() {
            await this.setRankedAnswers(this.answers.map(a => a.id));
            await this.sendAnswerRanked();
        },
        moveUp(index) {
            if (index > 0) {
                const tmp = this.answers[index - 1];
                this.$set(this.answers, index - 1, this.answers[index]);
                this.$set(this.answers, index, tmp);
            }
        },
        moveDown(index) {
            if (index < this.answers.length - 1) {
                const tmp = this.answers[index + 1];
                this.$set(this.answers, index + 1, this.answers[index]);
                this.$set(this.answers, index, tmp);
            }
        },
    },
};
</script>

<style lang="scss">
.drag-handle {
  cursor: grab;
}

.ranked-answer-button {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.flip-list-move {
  transition: transform 200ms ease;
}

.flip-list-enter-active, .flip-list-leave-active {
  transition: all 150ms ease;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

</style>
